import styles from './index.module.scss';

interface CheckInImageProps {
  image: string | undefined;
}

export const CheckInImage = ({ image }: CheckInImageProps) => {
  if (image == null) {
    return (
      <div className={`${styles['image']} ${styles['empty']}`}>無照片</div>
    );
  }

  return (
    <div className={styles['image']}>
      <img src={image} alt="check-in" />
    </div>
  );
};
